type EmailCapableIncident = {
  emailNotificationAvailable?: boolean;
  customer?: {
    email?: string;
  } | null;
};

export function isEmailNotificationAvailable(incident?: EmailCapableIncident | null): boolean {
  if (!incident) return false;
  if (incident.emailNotificationAvailable === true) return true;
  if (incident.emailNotificationAvailable === false) return false;
  return Boolean(incident.customer?.email?.trim());
}

export function emailRecipientFallback(incident?: EmailCapableIncident | null): string {
  return incident?.customer?.email?.trim() || "";
}
